import React from 'react';
import classNames from 'classnames';

import css from './IconStudio.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconStudio = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_2359_2730)">
    <path
      d="M1.55078 17.8782H22.1642"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.1642 4.62891L1.55078 9.04603"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.375 17.3518L3.75 9.10181L20.25 5.72681V17.7268" fill="#262338" />
    <path
      d="M3.375 17.3518L3.75 9.10181L20.25 5.72681V17.7268"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.70508 14.9343H17.0118"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.02148 8.72925V17.8792"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6934 4.94287V17.8787"
      stroke="#262338"
      strokeWidth="1.30716"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_2359_2730">
      <rect width="32" height="32" fill="white" />
    </clipPath>
  </defs>
</svg>

  );
};

export default IconStudio;
